import type { ReactNode } from "react";

export interface FrameBackgroundProps {
  children: ReactNode;
}

/**
 * Decorative full-bleed background rendered behind all other Frame chrome (z-0).
 * Use for hero swooshes, gradient backdrops, illustrations etc. Doesn't affect
 * layout flow.
 */
export function FrameBackground({ children }: FrameBackgroundProps) {
  return <>{children}</>;
}
